import React from 'react';
import ModuleBudgetEntry from '../../shared/ModuleBudgetEntry';

// =============================================================================
// Distribution › Fixed Costs
// The OPEX capture grid, showing only GL lines whose source_module is
// MOD_4_MOVE (set on Budget Setup > GL Lines). Same grid, same behaviour —
// see shared/ModuleBudgetEntry.jsx.
//
// Replaces the earlier dummy-data mockup.
// =============================================================================

const DistFixedCosts = () => (
  <ModuleBudgetEntry
    title="Distribution Fixed Costs"
    description="Baseline fixed warehousing and distribution costs. Capture and adjust; changes save automatically."
    module="MOD_4_MOVE"
  />
);

export default DistFixedCosts;
